import React, { useState } from 'react';
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  useTheme,
  useMediaQuery, IconButton
} from '@mui/material';
import ImageCarousel from '../HomePage/ImageCarousel';
import FeaturesSection from '../HomePage/FeaturesSection';
import { CIRCUIT_IMAGES } from '../../constants/Constants';

const Features = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
  <Box component="section"
      sx={{ background: "#F8F9FB",
        padding: { xs: '10px 16px 40px', sm: '10px 16px 40px', md: '10px 30px 80px'},
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: { xs: 5, sm: 6, md: 7 },}}>
          <Typography variant="h3" sx={{ fontWeight: 800, color:'#000', fontSize: { xs: 20, sm: 22, md: 28 }, mb: 1}}  >
            KEY FEATURES
          </Typography>

          <Typography variant="body1" sx={{ color:'#666', textAlign:'center', width: '100%', fontSize: { xs: 14, sm: 16 },}} >
            These tool features help build proficiency in schematics and stick diagrams—and prepare you for semiconductor careers.
          </Typography>
        </Box>
{/* 
        <Box sx={{ width: '100%', height: '100%', aspectRatio: {
      xs: '4/3',
      sm: '18/9',
      md: '21/9',
    }, mx: 'auto', mb: { xs: 4, md: 6 },}}>
          <ImageCarousel items={CIRCUIT_IMAGES} />
        </Box> */}

        <FeaturesSection />
      </Container>
    </Box>
  );
};

export default Features;
